import React, { lazy } from 'react';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    title: 'Kit De Checklists Cero Errores',
    desc: 'El sistema operativo del detailer pro. Nunca más te olvidés un paso en ningún trabajo.',
    img: 'https://cdn.magicpatterns.com/uploads/k7hJuS4jppufcRtLG5Tn5T/Bono_1.png'
  }, {
    id: 2,
    title: 'Presupuesto Pro + Condiciones',
    desc: 'Plantillas listas para enviar por WhatsApp. El cliente confirma. Vos trabajás tranquilo.',
    img: 'https://cdn.magicpatterns.com/uploads/gKsB6DYoQLfhwJCocDcRDP/Bono_2.png'
  }, {
    id: 3,
    title: 'Calculadora De Ganancia',
    desc: 'Sabé exactamente cuánto ganás por cada servicio antes de hacerlo. Sin sorpresas al final del mes.',
    img: 'https://cdn.magicpatterns.com/uploads/9iKhTRmMSFfRTbYcUiSLK9/Bono_3.png'
  }, {
    id: 4,
    title: 'Fotos Que Venden',
    desc: 'El sistema para fotografiar antes y después. Convertí cada trabajo en contenido que trae el próximo cliente.',
    img: 'https://cdn.magicpatterns.com/uploads/7BkyDxMh975hwRpWzWJZSh/Bono_4.png'
  }];
  return <section className="py-16 px-4 bg-gray-50 border-t border-gray-200" data-id="element-54">
      <div className="max-w-5xl mx-auto" data-id="element-55">
        <div className="text-center mb-12" data-id="element-56">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-57">
            🎁 Regalos especiales
          </h2>
          <p className="text-2xl font-bold text-red-600 uppercase tracking-wide" data-id="element-58">
            BONOS INCLUIDOS HOY
          </p>
          <p className="text-lg text-gray-600 font-medium" data-id="element-59">
            (Sin costo adicional)
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-6" data-id="element-60">
          {bonuses.map(bono => <div key={bono.id} className="bg-white rounded-xl md:rounded-2xl border-2 border-yellow-400 shadow-xl overflow-hidden flex flex-col" data-id="element-61">
              <a href="https://checkout.construyeprogreso.com/cart/48119785324714:1" className="w-full bg-gray-100 p-3 md:p-6 flex justify-center items-center hover:opacity-90 transition-opacity" data-id="element-62">
                <img src={bono.img} alt={bono.title} className="w-full max-w-[150px] md:max-w-[220px] object-cover drop-shadow-lg" loading="lazy" decoding="async" width={263} height={394} data-id="element-63" />
              </a>
              <div className="w-full p-3 md:p-6 flex flex-col flex-1" data-id="element-64">
                <div className="inline-block bg-yellow-100 text-yellow-800 px-2 py-0.5 md:px-4 md:py-1 rounded-full font-bold text-xs md:text-sm mb-2 md:mb-3 uppercase tracking-wider self-start" data-id="element-65">
                  Bono {bono.id}
                </div>
                <h3 className="text-sm md:text-xl font-black text-gray-900 mb-1 md:mb-3" data-id="element-66">
                  {bono.title}
                </h3>
                <p className="text-xs md:text-base text-gray-700 font-medium mb-3 md:mb-5 flex-1" data-id="element-67">
                  {bono.desc}
                </p>
                <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-4 bg-gray-50 p-2 md:p-3 rounded-lg border border-gray-200" data-id="element-68">
                  <div className="text-gray-500 font-medium text-xs md:text-sm" data-id="element-69">
                    Valor: <span className="line-through" data-id="element-70">$2.000</span>
                  </div>
                  <div className="text-green-600 font-black text-sm md:text-lg" data-id="element-71">
                    HOY: GRATIS
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}